import React from 'react';
import ApparelTees from '../ApparelTees';

const Masks = () => {
  return (
    <>
      <ApparelTees />
    </>
  );
};
export default Masks;
